const SERVICE_WORKER_PATH = "/media-cache-sw.js";

export function registerMediaServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(SERVICE_WORKER_PATH)
      .catch((error) => {
        console.error("Failed to register media service worker:", error);
      });
  });
}
